export default __webpack_public_path__ + "static/bg_branded_dollars-0a64ef41baab7afb884914148f1dea44.png";